/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from "@sentry/browser";
import { ReducerBuilder } from "./ReducerBuilder";
import * as ServiceTagActions from "../actions/serviceTags";
import { sendToSentry } from "../helpers/sentry";
import { IServiceTag } from "../interfaces/ServiceTagsInterface";

// helper function
export function getSpeciality(tags: IServiceTag[], id: number): string {
  if (Array.isArray(tags)) {
    return tags.find((item) => item.id === id)?.noun || "";
  }

  sendToSentry({
    tagKey: "function",
    tagValue: "getSpeciality",
    severity: Sentry.Severity.Debug,
    user: {},
    extras: {},
    error: tags
  });

  return "";
}

// reducer specific
const INITIAL_STATE = {
  collection: []
};

function setServiceTags(state: any, payload: any) {
  return { ...state, collection: payload };
}

function addServiceTag(state: any, payload: any) {
  return { ...state, collection: [...state.collection, payload] };
}

const reducer = ReducerBuilder.create(INITIAL_STATE)
  .mapAction(ServiceTagActions.Type.GET_SERVICETAGS, setServiceTags)
  .mapAction(ServiceTagActions.Type.POST_SERVICETAG, addServiceTag)
  .build();

export default reducer;
